export type HotelLookupField = "name" | "hotel_code" | "crs_code";

export const buildHotelLookupPath = (
  field: HotelLookupField,
  value: unknown
): string =>
  `/hotels?filter[status][value]=1&filter[${field}][value]=${encodeURIComponent(
    String(value)
  )}&include=brand_id`;

export default buildHotelLookupPath;
